import { useContext, useState } from "react";
import GenerateId from "../../../../../common/Utils/GenerateUniqueId";
import { GlobalContext } from "../../../../../common/Context";

const Gauge = ({ value = 0, title, width, titleStyle, valueStyle, type }) => {
  const { desktopView, tabletView, mobileView } = useContext(GlobalContext);

  // The following two functions are from this:
  // https://stackoverflow.com/a/18473154
  const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
    var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians),
    };
  };

  const describeArc = (x, y, radius, startAngle, endAngle) => {
    var start = polarToCartesian(x, y, radius, endAngle);
    var end = polarToCartesian(x, y, radius, startAngle);

    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    var d = [
      "M",
      start.x,
      start.y,
      "A",
      radius,
      radius,
      0,
      largeArcFlag,
      0,
      end.x,
      end.y,
    ].join(" ");

    return d;
  };

  const [gradUniqueId] = useState(`gauge_grad_${GenerateId()}`);
  const [shadowUniqueId] = useState(`gauge_shad_${GenerateId()}`);

  const strokeWidth = type === "total" ? 10 : 20;
  const radius = 40;
  const xOffset = 50;
  const yOffset = type === "total" ? 50 : 40;
  const startAngle = type === "total" ? -130 : 270;
  const endAngle = type === "total" ? 130 : 90;
  const startAngleBg =
    type === "total" ? -130 + 260 * (value / 100) : -90 + 180 * (value / 100);
  const height =
    mobileView || type === "total"
      ? width
      : tabletView
      ? "100%"
      : (width * 3) / 4;
  const viewBox = type === "total" ? "0 0 100 100" : "0 0 100 50";
  const titleY = type === "total" ? "95%" : desktopView ? "115%" : "140%";
  const valueY = type === "total" ? "60%" : desktopView ? "85%" : "80%";

  return (
    <svg width={width} height={height} viewBox={viewBox}>
      <defs>
        <linearGradient
          gradientTransform="rotate(-45)"
          id={gradUniqueId}
          x1="0"
          y1="0"
          x2="1"
          y2="1">
          <stop offset="0%" stopColor="#FA1A19" stopOpacity="1"></stop>
          <stop offset="20%" stopColor="#E5CB32" stopOpacity="1"></stop>
          <stop offset="70%" stopColor="#A1E135" stopOpacity="1"></stop>
        </linearGradient>
        <filter
          id={shadowUniqueId}
          width="160%"
          x="-20%"
          height="160%"
          y="-50%">
          <feOffset dx="0" dy="3" />
          <feGaussianBlur stdDeviation="5" result="offset-blur" />
          <feComposite
            operator="out"
            in="SourceGraphic"
            in2="offset-blur"
            result="inverse"
          />
          <feFlood floodColor="black" floodOpacity="0.2" result="color" />
          <feComposite operator="in" in="color" in2="inverse" result="shadow" />
          <feComposite operator="over" in="shadow" in2="SourceGraphic" />
        </filter>
      </defs>
      <g filter={`url(#${shadowUniqueId})`}>
        <path
          fill="transparent"
          stroke={`url(#${gradUniqueId})`}
          strokeWidth={strokeWidth}
          d={describeArc(xOffset, yOffset, radius, startAngle, endAngle)}
          strokeLinecap={type === "total" && "round"}
        />
        <path
          fill="transparent"
          stroke="#eaeaea"
          strokeWidth={strokeWidth}
          d={describeArc(xOffset, yOffset, radius, startAngleBg, endAngle)}
          strokeLinecap={value === 0 && "round"}
        />
        {type === "total" && (
          <path
            fill="transparent"
            stroke="#eaeaea"
            strokeWidth={strokeWidth}
            d={describeArc(xOffset, yOffset, radius, endAngle, endAngle)}
            strokeLinecap="round"
          />
        )}
      </g>
      <text y={valueY} x="50%" textAnchor="middle" style={valueStyle}>
        {value}
      </text>
      <text y={titleY} x="50%" textAnchor="middle" style={titleStyle}>
        {title}
      </text>
    </svg>
  );
};

export default Gauge;
